import { NarrativeSectionKey } from '@marketing-milk/interfaces'

export type SectionKind =
  | 'performance'
  | 'narrative'
  | 'audience-placeholder'
  | 'creative-placeholder'
  | 'approval'

export type SectionKey =
  | 'performance-review'
  | NarrativeSectionKey
  | 'audience-framework'
  | 'creative'
  | 'final-approval'

export interface SectionDef {
  key: SectionKey
  label: string
  kind: SectionKind
}

export const SECTIONS: SectionDef[] = [
  { key: 'performance-review', label: 'Performance Review', kind: 'performance' },
  { key: 'cooking-up', label: 'Cooking up', kind: 'narrative' },
  { key: 'data-world', label: 'Data World', kind: 'narrative' },
  { key: 'website', label: 'Website', kind: 'narrative' },
  { key: 'outstanding-needs', label: 'Outstanding Needs', kind: 'narrative' },
  { key: 'feedback', label: 'Feedback', kind: 'narrative' },
  { key: 'upcoming-meetings', label: 'Upcoming Meetings', kind: 'narrative' },
  { key: 'audience-framework', label: 'Audience framework', kind: 'audience-placeholder' },
  { key: 'creative', label: 'Creative', kind: 'creative-placeholder' },
  { key: 'final-approval', label: 'Final Approval', kind: 'approval' },
]

export const sectionNumberFor = (key: SectionKey): string => {
  const idx = SECTIONS.findIndex(s => s.key === key)
  return String(idx + 1).padStart(2, '0')
}
